var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "trip-generate-connection-print"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "is-full-screen": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('div', {
    staticClass: "form group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "btn btn-info",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showManifest('Mongo')
      }
    }
  }, [_vm._v("Print Manifest Mongo")]), _vm._v(" "), (['ajitab.deshmukh@xpressbees.com', 'saurabh.jaiswal@xpressbees.com', 'kishor.thorat@xpressbees.com'].includes(_vm.printBy)) ? _c('span', {
    staticClass: "btn btn-info",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showManifest('Backup')
      }
    }
  }, [_vm._v("Print Manifest Backup")]) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplay),
      expression: "isDisplay"
    }]
  }, [_c('fieldset', [_c('div', {
    attrs: {
      "id": "printManifestContent"
    }
  }, [_c('div', [_c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm.printDate))]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.printBy))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("BusyBees Logistics Solutions Private Limited\n                        ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Reg. Office Address :")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("S. No. 58/3/1, Kapil Woodrow Estate, Building B,, 8th Floor, Flat No. 803, Azadnagar, Wanawadi,Pune – 411040.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v("Source Hub Name & Address : " + _vm._s(_vm.ConnectionDetails.SourceHubName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ConnectionDetails.SourceHubAddress))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v("Destination Hub Name & Address : " + _vm._s(_vm.ConnectionDetails.DestinationHubName) + "\n                        ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ConnectionDetails.DestinationHubAddress))])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.ManifestDetails), function(data, index) {
    return _c('div', {
      staticClass: "print-only",
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "13"
      }
    }, [_c('strong', [_vm._v("Client Name - " + _vm._s(data.clientname) + "\n                          ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "13"
      }
    }, [_c('strong', [_vm._v("Delhi - Shipment Manifest Date and Time " + _vm._s(_vm._f("moment")(data.ScheduleDate)) + "\n                          ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "13"
      }
    }, [_c('strong', [_vm._v("GST Reg No. :BUrewe234234ERE\n                          ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "7"
      }
    }, [_c('strong', [_vm._v("(Manifest number - " + _vm._s(data.ManifestNumber) + ")")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "6"
      }
    }, [_c('strong', [_vm._v("Schedule ID: " + _vm._s(data.ScheduleId) + "\n                          ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("SR NO")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("AWB No. ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("EBN Number ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("POID/Ref number ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("NPS Count")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Consigner Name & Address ")])]), _vm._v(" "), _c('td', {
      staticClass: "td-width"
    }, [_c('strong', [_vm._v("Consignee Name & Address ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Origin")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Destination")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Quantity")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Description of the Product ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Weight")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("MRP")])])]), _vm._v(" "), _vm._l((data.value), function(mfdata, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.AWBNo) + " ")]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.EBNNo))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.POID))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.NPSCount))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_c('strong', [_vm._v(_vm._s(mfdata.ConsignerName))]), _c('br'), _vm._v("\n                          " + _vm._s(mfdata.ConsignerAddress))]), _vm._v(" "), _c('td', {
        staticClass: "td-width"
      }, [_c('strong', [_vm._v(_vm._s(mfdata.ConsigneeName) + "\n                          ")]), _c('br'), _vm._v(_vm._s(mfdata.ConsigneeAddress) + " " + _vm._s(mfdata.ConsigneePinCode))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.OriginHub))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.DestinationHub))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.Qty))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.ProductInfo))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.Weight))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.MRP))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "10"
      }
    }, [_c('strong', [_vm._v("Total Amount")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm._f("TotalMRP")(data.value)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "10"
      }
    }, [_c('strong', [_vm._v("Total Shipments ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(data.value.length))])])], 2)])])
  }), _vm._v(" "), _vm._l((_vm.ManifestDetails), function(data, index) {
    return (!_vm.isHidePrintManifestReport) ? _c('div', {
      staticClass: "no-print",
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "13"
      }
    }, [_c('strong', [_vm._v("Client Name - " + _vm._s(data.clientname) + "\n                          ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "13"
      }
    }, [_c('strong', [_vm._v("Delhi - Shipment Manifest Date and Time " + _vm._s(_vm._f("moment")(data.ScheduleDate)) + "\n                          ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "13"
      }
    }, [_c('strong', [_vm._v("GST Reg No. :BUrewe234234ERE\n                          ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "7"
      }
    }, [_c('strong', [_vm._v("(Manifest number - " + _vm._s(data.ManifestNumber) + ")")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "6"
      }
    }, [_c('strong', [_vm._v("Schedule ID: " + _vm._s(data.ScheduleId) + "\n                          ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("SR NO")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("AWB No. ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("EBN Number ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("POID/Ref number ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("NPS Count")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Consigner Name & Address ")])]), _vm._v(" "), _c('td', {
      staticClass: "td-width"
    }, [_c('strong', [_vm._v("Consignee Name & Address ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Origin")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Destination")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Quantity")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Description of the Product ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Weight")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("MRP")])])]), _vm._v(" "), _vm._l((data.value), function(mfdata, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.AWBNo) + " ")]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.EBNNo))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.POID))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.NPSCount))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_c('strong', [_vm._v(_vm._s(mfdata.ConsignerName))]), _c('br'), _vm._v("\n                          " + _vm._s(mfdata.ConsignerAddress))]), _vm._v(" "), _c('td', {
        staticClass: "td-width"
      }, [_c('strong', [_vm._v(_vm._s(mfdata.ConsigneeName) + "\n                          ")]), _c('br'), _vm._v(_vm._s(mfdata.ConsigneeAddress) + " " + _vm._s(mfdata.ConsigneePinCode))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.OriginHub))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.DestinationHub))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.Qty))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.ProductInfo))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.Weight))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(mfdata.MRP))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "10"
      }
    }, [_c('strong', [_vm._v("Total Amount")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm._f("TotalMRP")(data.value)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "10"
      }
    }, [_c('strong', [_vm._v("Total Shipments ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(data.value.length))])])], 2)])]) : _vm._e()
  }), _vm._v(" "), (_vm.isHidePrintManifestReport) ? _c('div', {
    staticClass: "no-print",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "13"
    }
  }, [_c('strong', [_vm._v("Note: "), _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Report are hidden to comply with confidentiality and security policies.")])])])])])])]) : _vm._e(), _vm._v(" "), _c('br')], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplay),
      expression: "isDisplay"
    }],
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.printConfig
    },
    on: {
      "click": function($event) {
        return _vm.printManifest()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_c('span', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Send Mail")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.printConfig
    },
    on: {
      "click": function($event) {
        return _vm.downloadPDF()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download PDF")])])])], 1)]), _vm._v(" "), (_vm.showemailpage == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Send Mail"
    },
    model: {
      value: (_vm.showemailpage),
      callback: function($$v) {
        _vm.showemailpage = $$v
      },
      expression: "showemailpage"
    }
  }, [_c('fieldset', [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Send Mail")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeSendMailPage
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Mail ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-envelope'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailId),
      expression: "mailId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('mailId')
    },
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "type": "text",
      "name": "mailId",
      "id": "mailId",
      "placeholder": "Enter MailId, Use Comma For Multiple MailId's"
    },
    domProps: {
      "value": (_vm.mailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailId = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.emailIdErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdErrorMSG))]) : _vm._e(), _vm._v(" "), (_vm.emailIdValidationMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdValidationMSG))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.SendMailFunction
    }
  }, [_vm._v("Send Mail")]), _vm._v(" \n                  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormForMail
    }
  }, [_vm._v("Reset Mail")]), _vm._v(" \n\n                ")])])])])])])]) : _vm._e()], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-788eb94c","hasScoped":true}!./src/views/components/TripGenerateConnectionPrint/TripGenerateConnectionPrint.html
// module id = 935
// module chunks = 2